<!-- <template>
  <div class="page-content">
    <div class="search-form" style="height: 100px">
      <el-form :inline="true" :model="formInline" class="other-form-inline">
        <el-form-item>
          <el-input
            v-model="searchParams.searchData"
            placeholder="申请名称"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="marginRight5" type="primary" @click="search"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="panel-body-apply" v-show="showTree">
      <ul class="apply-processes clearfix">
        <li
          class="fl text-center pointer"
          v-for="(item, index) in applyProcesses"
          :key="index"
          @click="addApply(item)"
        >
          <div class="apply-name">
            <p>{{ item.name }}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="add-apply-content">
      <div class="ah-flex applyList" v-show="!showTree">
        <div class="applyTree">
          <ul>
            <li
              v-for="(item, index) in groupList"
              :key="index"
              :class="{ groupActive: scrollIndex === index }"
              @click="jumpScroll(index)"
              v-show="index != groupList.length - 1"
            >
              {{ item.typeName ? item.typeName : "其他" }}
            </li>
          </ul>
        </div>
        <div class="panel-body-apply scrollContent">
          <div
            v-for="(item, index) in groupList"
            :key="index"
            class="scrollTreeList"
            v-show="index != groupList.length - 1"
          >
            <div class="scrollItemTree" :class="'scrollItemTree' + index">
              <div class="firstLevel">
                <span class="firstLevelName"
                  >{{ item.typeName ? item.typeName : "其他"
                  }}<span class="firstLevelNum"
                    >({{ item.children.length }})</span
                  ></span
                >
              </div>
              <ul class="apply-processes clearfix">
                <li
                  class="fl text-center pointer"
                  v-for="(val, key) in item.children"
                  :key="key"
                  @click="addTreeApply(index, key)"
                >
                  <div class="apply-name">
                    <p>{{ val.name }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <applyIframe ref="applyIframe"></applyIframe>
  </div>
</template>
<script>
import { powerProcDefList } from "@/apis/index";
import applyIframe from "./applyIframe.vue";
export default {
  data() {
    return {
      searchParams: {
        searchData: "",
      },
      groupList: [],
      showTree: true,
      applyProcesses: [],
      scrollIndex: 0,
      spinning: false,
    };
  },
  components: {
    applyIframe,
  },
  mounted() {
    window.onmessage = function (event) {
      console.log(event);
    };
    this.search();
    this.$nextTick(() => {
      let navContent = document.querySelectorAll(".scrollItemTree");
      var scrollBody = document.getElementsByClassName("scrollContent")[0];
      const offsetTopArr = [];
      navContent.forEach((el) => {
        offsetTopArr.push(el.offsetTop);
      });
      scrollBody.addEventListener("scroll", function (e) {
        var scrollTop = e.target.scrollTop;
        offsetTopArr.forEach((el, index) => {
          if (scrollTop >= el) {
            this.scrollIndex = index;
          }
        });
      });
    });
  },
  methods: {
    search() {
      this.spinning = true;
      let params = {
        procDefName: this.searchParams.searchData,
      };
      powerProcDefList(params).then((data) => {
        this.applyProcesses = [];
        let typeNameMap = {};
        for (var i = 0; i < data.length; i++) {
          var obj = {
            procDefId: data[i].id,
            name: data[i].name,
            procInstState: "",
          };
          if (!typeNameMap[data[i].typeName]) {
            typeNameMap[data[i].typeName] = [];
          }
          typeNameMap[data[i].typeName].push(obj);
          this.applyProcesses.push(obj);
        }

        let groupList = [];
        for (let i in typeNameMap) {
          let obj = {
            children: typeNameMap[i],
            typeName: i,
          };
          groupList.push(obj);
        }
        let otherList = groupList.filter((val) => {
          return val.typeName == "";
        });
        if (otherList.length) {
          let emptyList = otherList[0].children;
          if (emptyList.length == this.applyProcesses.length) {
            this.showTree = true;
          } else {
            this.showTree = false;
          }
          let otherIndex = "";
          groupList.forEach((val, index) => {
            if (val.typeName == "") {
              otherIndex = index;
            }
          });
          if (otherIndex || otherIndex === 0) {
            let otherInfo = groupList.splice(otherIndex, 1);
            let sortGroup = groupList.concat(otherInfo);
            this.groupList = sortGroup;
          } else {
            this.groupList = groupList;
          }
        } else {
          this.showTree = false;
          this.groupList = groupList;
        }
        this.groupList.push({ typeName: "", children: [] });
        this.spinning = false;
      });
    },
    jumpScroll(index) {
      document.querySelector(".scrollItemTree" + index).scrollIntoView({
        behavior: "smooth",
      });
      this.scrollIndex = index;
    },
    addApply(info) {
      this.$refs.applyIframe.showToggle(info);
      // this.applyProcesses[index].level = 0;
      // this.$refs.applyForm.showToggle(this.applyProcesses[index], "newApply");
    },
    addTreeApply(parentIndex, index) {
      this.$refs.applyForm.showToggle(
        this.groupList[parentIndex].children[index],
        "newApply"
      );
    },
  },
};
</script> -->
<template>
  <div class="crewHome">
    <iframe
      ref="iframeRef2"
      :src="ismSrc"
      width="100%"
      height="100%"
      frameborder="0"
    ></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ismSrc: "",
    };
  },
  mounted() {
    const savedSession = this.saveSessionData();
    let httpUrl = "";
    let token = window.sessionStorage.getItem("otherToken");
    if (process.env.NODE_ENV === "development") {
      httpUrl = "http://test.lanshuimu.com";
    } else {
      httpUrl = "https://www.lanshuimu.com";
    }
    this.ismSrc = httpUrl + "/#!/frame/apply-add?platToken=" + token;
    console.log(this.ismSrc);
    this.$refs.iframeRef2.addEventListener("load", () => {
      // 恢复会话数据
      this.restoreSessionData(savedSession);
    });
  },
  methods: {
    saveSessionData() {
      const data = {};
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        data[key] = sessionStorage.getItem(key);
      }
      return data;
    },
    restoreSessionData(data) {
      // 先清除所有数据
      // sessionStorage.clear();

      // 恢复保存的数据
      Object.keys(data).forEach((key) => {
        if (key != "token") {
          sessionStorage.setItem(key, data[key]);
        }
      });
    },
  },
};
</script>
